import React, { useContext, useEffect, useState } from "react"
import { ActivityIndicator, FlatList, RefreshControl, View } from "react-native"
import styles from "./styles"
import CustomEvaluationItem from "@Components/CustomEvaluationItem"
import { KnowledgeService } from "@Services/Knowledge/Knowledge.Service"
import { baseColors } from "@Constants/baseStyles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { QuizzContext } from "@Providers/QuizzProvider"
import { userAtom } from "@Recoil/Atom/userAtom"
import { useRecoilValue } from "recoil"
import { quizAldreadyReplied } from "./EvaluationLogic"
import { useUserPrograms } from "../../../../Hooks/useUserPrograms"

const Evaluation = () => {
    const [selectedId, setSelectedId] = useState(null)
    const [quizzLists, setQuizzLists] = useState([])
    const [fetching, setFetching] = useState(false)
    const { selectedKnowledge } = useContext(QuizzContext)
    const user = useRecoilValue(userAtom)

    const { fetchUserPrograms, currentUserProgram, fetchingUserPrograms } = useUserPrograms()

    const programId = currentUserProgram?.program?.id ?? 0

    const fetchQuizzList = () => {
        setFetching(true)
        KnowledgeService.getQuizzBytype(selectedKnowledge, programId)
            .then((res) => {
                const data = res?.data?.data
                setQuizzLists(data)
                setFetching(false)
            })
            .catch(() => {
                setFetching(false)
            })
    }

    useEffect(() => {
        if (programId > 0) {
            fetchQuizzList()
        }
    }, [selectedKnowledge, programId])

    useEffect(() => {
        fetchUserPrograms()
    }, [])

    const quizzItems = Array.from(quizzLists ?? [], (item) => {
        const hasReplied = quizAldreadyReplied({ quizItem: item, userId: user?.id })

        return {
            id: item.id,
            title: item.title,
            subContent: {
                title: hasReplied ? "Voir le résultat" : "Démarrer le quiz"
            },
            questions: item.questions,
            hasReplied
        }
    })

    const loading = fetching || fetchingUserPrograms

    const renderEmptyCmpt = (
        <View style={{ flex: 1, alignItems: "center", justifyContent: "center", marginVertical: "50%" }}>
            <OpenSansText fontSize={18}>Aucune évaluation.</OpenSansText>
        </View>
    )

    const renderItem = ({ item }) => <CustomEvaluationItem item={item} setSelectedId={setSelectedId} />

    return (
        <View style={styles.container}>
            {loading ? (
                <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                    <ActivityIndicator color={baseColors.green.primary} size={50} />
                </View>
            ) : (
                <FlatList
                    data={quizzItems}
                    showsVerticalScrollIndicator={false}
                    ListEmptyComponent={renderEmptyCmpt}
                    renderItem={renderItem}
                    keyExtractor={(item) => item?.id?.toString()}
                    extraData={selectedId}
                    contentContainerStyle={styles.contentContainer}
                    refreshControl={<RefreshControl onRefresh={fetchQuizzList} />}
                />
            )}
        </View>
    )
}

export default Evaluation
